import { render, staticRenderFns } from "./allGradesComparison_old.vue?vue&type=template&id=a73867cc&scoped=true&"
import script from "./allGradesComparison_old.vue?vue&type=script&lang=js&"
export * from "./allGradesComparison_old.vue?vue&type=script&lang=js&"
import style0 from "./allGradesComparison_old.vue?vue&type=style&index=0&id=a73867cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73867cc",
  null
  
)

export default component.exports